import React, {useRef, useEffect} from 'react'
import './Header.scss'
import flatListToHierarchical from '../../functions/flatListToHierarchical'
import MenuHeader from '../MenuHeader/MenuHeader'
import MenuPrimary from '../MenuPrimary/MenuPrimary'
import Logo from '../../assets/svg/logo.inline.svg'
import {Link} from 'gatsby'

export default function Header({menus}) {

	let menuPrimary = flatListToHierarchical(menus.primary.menuItems.nodes)
	let menuHeader = flatListToHierarchical(menus.header.menuItems.nodes)

	let container = useRef()

	const hideMenu = () => {
		if(container.current !== null) {
			container.current.classList.add('hidden')
		}
	}

	const showMenu = () => {
		if(container.current !== null) {
			container.current.classList.remove('hidden')
		}
	}

	useEffect(() => {
		let scrollPosition = 0;
		const handleScroll = () => {
			if(window.innerWidth > 750) {
				let st = window.pageYOffset || document.documentElement.scrollTop;
				if(scrollPosition > 140) {
					container.current.classList.add('scrolling')
				} else {
					container.current.classList.remove('scrolling')
				}
				scrollPosition = st
			} else {
				container.current.classList.remove('scrolling')
			}
		}

		window.addEventListener('scroll', handleScroll)
		window.addEventListener('resize', handleScroll)
		return () => {
			window.removeEventListener('scroll', handleScroll)
			window.removeEventListener('resize', handleScroll)
		}

	}, [])

	return(
		<header className="Header" ref={container}>
			<div className="inner">
				<div className="logo">
					<Link to="/" aria-label="Tilbake til forsiden">
						<span aria-hidden="true">Tilbake til forsiden</span>
						<Logo />
					</Link>
				</div>
				<nav>
					<MenuHeader menu={menuHeader} />
					<MenuPrimary menu={menuPrimary} headerMenu={menus.header.menuItems.nodes} />
				</nav>
			</div>
		</header>
	)
}